import React from "react";
import { InputAdornment, StandardTextFieldProps, styled, TextField } from "@mui/material";

interface SearchFieldInterface extends StandardTextFieldProps {
  placeholder?: string;
  searchIconPosition?: "end" | "start";
}

const StyledTextField = styled(TextField)(
  () => ({
    '& .MuiInputAdornment-root': {
      color: "rgba(18, 18, 18, 0.5)"
    }
  }),
);

const SearchField = ({ placeholder = "Search", searchIconPosition, ...props }: SearchFieldInterface) => {
  return (
    <StyledTextField  {...props} variant="standard" placeholder={placeholder} InputProps={{
      disableUnderline: true,
      endAdornment: searchIconPosition && searchIconPosition === "end" ? <InputAdornment position="end">
        <i className="far fa-search"></i>
      </InputAdornment> : null,
      startAdornment: searchIconPosition && searchIconPosition === "start" ? <InputAdornment position="start">
        <i className="far fa-search"></i>
      </InputAdornment> : null,
      autoComplete: "off",
    }} />
  )
}

export default SearchField;